
<template>
  <input class="search-input input--text" aria-label="Search" name="q" :placeholder="placeholder" v-model="currentValue" type="text" id="searchq" maxlength="50" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" autofocus="autofocus" :autocomplete="autocomplete" @keyup="$emit('keyup')" @focus="$emit('focus')"/>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default: 'Search'
    },
    type: {
      type: String,
      default: 'text'
    },
    autocomplete: String
  },
  data () {
    return {
      initialized: false,
      currentValue: this.value
    }
  },
  watch: {
    currentValue (p, c) {
      this.$emit('input', this.currentValue)
    }
  },
  methods: {
    update (val) {
      this.currentValue = val
    },
    clearInput () {
      return (this.currentValue != '') ? this.update('') : ''
    }
  }
}
</script>

<style scoped lang="scss">
  .search-input {
    padding: 0 rem(28) 0 rem(42);
    height: 43px;
    font-size: rem(14);
    line-height: rem(18);
    width: 100%;
    margin: 0;
    border-radius: 2px;
    border: 1px solid $color-off-black;

    @include ie {
      margin-top: -2px;
    }
  }

</style>
